import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { MapService } from '../../../services/map/map.service';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';
declare var Clipboard;

@Component({
    selector: 'app-share-map',
    templateUrl: './share-map.component.html',
    styleUrls: ['./share-map.component.css']
})
export class ShareMapComponent implements OnInit, OnDestroy {
    private url = "";
    //paràmetres entrats via URL
    private queryParams;

    private translations = {
    }


    //Missatges a mostrar al div
    private issues: Object[] = [];
    private mailBody = this.translations["mailBody"] + this.url;
    private mailSubject = this.translations["mailSubject"] + this.url;
    subscription: Subscription;
    copyText = "Copiar";
    buttonClasses = {
        "btn-default": true,
        "btn-success": false
    };
    constructor(private mapService: MapService, private route: ActivatedRoute, private router: Router, private location: Location, private translateService: TranslateService) {
        this.subscription = this.mapService.getUrl().subscribe(url => { this.url = url; });
        this.translateService.get(
            ['facebookSbTitle', 'facebookSbDescription', 'whatsappSbTitle', 'whatsappSbDescription', 'twitterSbTitle', 'twitterSbDescription', 'linkedinSbTitle', 'linkedinSbDescription', 'mailSubject', 'mailBody']
        ).subscribe((res) => {
            this.translations = res;
        });
    }
    ngOnInit() {
        let clipboard_ = new Clipboard('#btnCopy');

        clipboard_.on('success', (event) => {
            console.info('Action:', event.action);
            console.info('Text:', event.text);
            console.info('Trigger:', event.trigger);
            this.copyText = "Copiat";
            this.buttonClasses["btn-default"] = false;
            this.buttonClasses["btn-success"] = true;
            setTimeout(() => {
                this.copyText = "Copiar";
                this.buttonClasses["btn-default"] = true;
                this.buttonClasses["btn-success"] = false;
            }, 5000);
            event.clearSelection();
        });

        clipboard_.on('error', (event) => {
            console.error('Action:', event.action);
            console.error('Trigger:', event.trigger);
            this.issues.push({ message: "Error copiant" });
        });

    }
    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/tools/share-map/share-map.component.ts